import { Map } from 'immutable';
import Constants from '../../constants/index';

import { UserRecord } from '../../records/index';
import { reducerMerger } from '../helpers/entities';

export const DEFAULT_STATE = Map({});

//  Merges in data regarding Confluence users. Sources are both Confluence REST and CQ Micros.
const users = reducerMerger(
	[
		Constants.FETCH_USER,
		Constants.FETCH_USERS,
		Constants.SEARCH_QUESTIONS,
		Constants.FETCH_QUESTION_LIST,
		Constants.FETCH_QUESTION,
		Constants.FETCH_QUESTION_RELATED,
		Constants.FETCH_ANSWERS,
		Constants.FETCH_ANSWER,
	],
	'users',
	UserRecord,
	DEFAULT_STATE,
);

export default users;
